module.exports = __webpack_public_path__ + "static/media/bg.5675aea2.jpg";